import DeviceStorage  from '../components/DeviceStorage/DeviceStorage';
import { LOGIN_EMAIL } from '../AAF/Auth/authConstants';
import { getUrlRedirectBack } from 'src/components/Modal/functions/ModalKeepWatching/functions';

class HistoryRegion {

  static goUrlRegister(){
    this.region = DeviceStorage.getItem('region');
    this.history = {};

    switch(this.region) {
      case 'brasil': {
          this.history = {
            pathname: '/register',
          }
        break;
      }
      default: {
        this.history = '/register';
        break;
      }
    }
    return this.history;
  }

  static getUrlLogin(modalType, props, back, islogin){
    this.region = DeviceStorage.getItem('region');
    switch(this.region) {
      case 'brasil': {
        props.showModal({
          modalType: modalType,
          modalProps: {
            callback: (type) => {
              props.history.push({
                pathname: '/login',
                typeRegisterNet: type
              })
            },
            onClose: () => {
              const urlRedirect = getUrlRedirectBack('/landing');
              props.history.push(urlRedirect);
            },
          },
        });
        break;
      }
      default: {
        if(!back && !islogin) {
          props.history.push('/login');
        } else if (islogin) {
          const urlRedirect = getUrlRedirectBack('/landing');
          props.history.push(urlRedirect);
        }
        break;
      }
    }
    return this.history;
  }
}

export default HistoryRegion;


// WEBPACK FOOTER //
// ./src/utils/HistoryRegion.js